import { ReactNode } from 'react';
import { useIsUserLoggedIn } from 'pages/Auth/hooks';
import AblyContextProvider from './AblyProvider';

/**
 * Mounts a single shared Ably Realtime client for the SPA session while the user is logged in.
 *
 * We also mount when a JWT exists in storage but the user object is not hydrated yet; otherwise
 * routes can render Main (private + token) before `useIsUserLoggedIn` is true and hooks like
 * `useAbly` would run without an AblyProvider.
 */
const AppAblyProvider = ({ children }: { children: ReactNode }) => {
  const isLoggedIn = useIsUserLoggedIn();
  const hasAccessToken = typeof globalThis.localStorage !== 'undefined' && Boolean(globalThis.localStorage.getItem('access'));
  const shouldMountAbly = isLoggedIn || hasAccessToken;

  if (!shouldMountAbly) {
    return <>{children}</>;
  }

  return <AblyContextProvider>{children}</AblyContextProvider>;
};

export default AppAblyProvider;
